/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';

import { useAction } from '../../../Common/hooks';
import { setAgenciesFilters } from '../../actions';
import { getAgenciesFilters } from '../../selectors';
import { agenciesFiltersInitialState } from '../../reducers';
import { getAgenciesFilterOptions } from '../../services';

const useAgenciesFilterBar = () => {
  const storeFilters = useSelector(getAgenciesFilters);
  const setStoreFilters = useAction(setAgenciesFilters);
  const [showResetButton, setShowResetButton] = useState(false);
  const [partnersOptions, setPartnersOptions] = useState([]);
  const [filters, setFilters] = useState({ ...storeFilters });

  useEffect(() => {
    const callFilterOptions = async () => {
      const filterOptions = await getAgenciesFilterOptions();
      const [partnersFilterOptions] = filterOptions;

      setPartnersOptions(partnersFilterOptions);
    };

    callFilterOptions();
  }, []);

  useEffect(() => {
    setStoreFilters(filters);
    setShowResetButton(!isEqual(filters, agenciesFiltersInitialState));
  }, [filters]);

  const handleFilterChanges =
    filterName =>
    ({ target: { value } }) => {
      const filter = { [filterName]: value };

      setFilters({
        ...filters,
        ...filter,
      });
    };

  const handleResetFilter = () => {
    setFilters({ ...agenciesFiltersInitialState });
    setShowResetButton(false);
  };

  const handleToggleSwitch = () => {
    setFilters({ ...filters, active: !filters.active });
  };

  return {
    showResetButton,
    handleFilterChanges,
    handleToggleSwitch,
    handleResetFilter,
    partnersOptions,
    filters,
  };
};

export default useAgenciesFilterBar;
